/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GetTenantResponse extends models.TenantDetails {
    getFixupPrototypeFunction() { return GetTenantResponse.fixupPrototype; }

    static newInstance(model: Partial<GetTenantResponse>): GetTenantResponse {
        let obj = Object.assign(new GetTenantResponse(), model);
        GetTenantResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GetTenantResponse>): GetTenantResponse {
        if (!model) return null;
        return GetTenantResponse.newInstance(<GetTenantResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GetTenantResponse) {
        if (!obj) return;

        models.GetTenantResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GetTenantResponse): boolean {
        if (models.TenantDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GetTenantResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.activity_queue_notifications) {
            models.ActivityQueueNotificationDetails.fixupPrototype(this.activity_queue_notifications);
        }
        if (this.email_notify) {
            models.EmailNotifyConfiguration.fixupPrototype(this.email_notify);
        }
        if (this.configuration_management) {
            models.TenantConfigurationManagementOptions.fixupPrototype(this.configuration_management);
        }
    }

    /**
     * metadata is a freeform JSON. It allows to store custom keys and values. It will be useful for storing information about an external applications that will refer to CoreStack tenant
     */
    metadata: any;

    /**
     * Name of the user created this tenant.
     */
    created_by: string;

    /**
     * Name of the user last updated this tenant.
     */
    updated_by: string;

    /**
     * DateTime in UTC when the tenant was last updated.
     */
    updated_at: string;

    /**
     * Name of the CoreStack account under which this tenant resides.
     */
    account_name: string;

    activity_queue_notifications: models.ActivityQueueNotificationDetails;

    /**
     * Email notification configuration
     */
    email_notify: models.EmailNotifyConfiguration;

    configuration_management: models.TenantConfigurationManagementOptions;

}
